import {
  Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle
} from '@material-ui/core';
import { Sync } from '@material-ui/icons';
import { useState } from 'react';
import { useStyles } from './styles';
import {
  useQuizAssessmentTestDataProvider
} from "../../../../providers/data-provider/quiz-assessment-test.data.provider";

export function NewAttempt({ id, onSubmitted, status }) {
  const testRepo = useQuizAssessmentTestDataProvider();
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleConfirm = () => {
    setOpen(false);
    testRepo.removeTest(id).then(() => onSubmitted());
  };

  return (
      <>
        <Button
            variant="outlined"
            size="small"
            startIcon={<Sync />}
            className={classes.retryButton}
            disabled={testRepo.loading || !status}
            onClick={() => setOpen(true)}
        >
          Liberar Nova Tentativa
        </Button>
        <Dialog open={open} onClose={() => setOpen(false)}>
          <DialogTitle>Conceder nova tentativa</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Tem certeza de que deseja liberar uma nova tentativa? O resultado atual do aluno será excluído e ele poderá realizar a avaliação novamente
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpen(false)} color="default">
              Cancelar
            </Button>
            <Button onClick={handleConfirm} color="primary" variant="contained">
              Confirmar
            </Button>
          </DialogActions>
        </Dialog>
      </>
  );
}
